<script lang="ts">
	import { _ } from 'svelte-i18n';
	import Icon from '$lib/components/Icon/Icon.svelte';
	import Button from '$lib/components/Button/Button.svelte';
	import { getHubStores } from '$lib/stores/hubStores';

	const { activities } = getHubStores();

	const itemsOnPage = 5;
	const totalPages = Math.ceil($activities.length / itemsOnPage);
	$: currentPage = 1;

	const prevPage = () => {
		if (currentPage > 1) {
			currentPage--;
		}
	};
	const nextPage = () => {
		if (currentPage < totalPages) {
			currentPage++;
		}
	};

	$: currentActivities = $activities.slice(
		(currentPage - 1) * itemsOnPage,
		currentPage * itemsOnPage
	);
</script>

<div class="header">
	<h2>{$_('post.activity.latest.heading')}</h2>
	<p>{$_('post.activity.invites.msg')}</p>
</div>
<ul>
	{#each currentActivities as activity}
		<li>
			<!-- TODO: Is Sparq1Survey needed? -->
			{#if activity.type === 'Survey' || activity.type === 'Sparq1Survey'}
				<Icon icon="survey" size="35" color="#0d8eee" />
			{:else if activity.type === 'Forum'}
				<Icon icon="discussion" size="35" color="#25ce8a" />
			{/if}
			<div>
				<div>{activity.name}</div>
				<div class="type">
					{#if activity.type === 'Survey' || activity.type === 'Sparq1Survey'}
						{$_('post.activity.survey')}
					{:else if activity.type === 'Forum'}
						{$_('post.activity.discussion')}
					{/if}
				</div>
			</div>
			<a href={activity.url} target="_blank" rel="noreferrer" class="start"
				><Button displayType="outline">{$_('common.start')}</Button></a>
		</li>
	{/each}
</ul>
<div class="footer">
	<div class="arrows" class:disabled={currentPage == 1}>
		<Icon icon="left-chevron" color="rgb(105 126 142)" size="11" onClick={prevPage} />
	</div>
	<div>{$_('common.page.of.pages', { values: { page: currentPage, pages: totalPages } })}</div>
	<div class="arrows" class:disabled={currentPage == totalPages}>
		<Icon icon="right-chevron" color="rgb(105 126 142)" size="11" onClick={nextPage} />
	</div>
</div>

<style>
	h2 {
		margin: 0;
		font-size: var(--fontSizeSmall);
		font-weight: bold;
	}

	p {
		margin: 0;
		font-size: var(--fontSizeSmaller);
	}

	ul {
		padding: var(--gutterMedium);
	}

	li {
		display: flex;
		align-items: center;
		padding-block: var(--gutterMedium) var(--gutterMedium);
		border-block-end: 1px solid rgb(238 238 238);
		gap: 10px;
	}

	.header {
		padding: var(--gutterMedium);
	}

	.type {
		color: var(--hubBodyFontColor);
		font-size: var(--fontSizeSmaller);
	}

	.start {
		margin-inline-start: auto;
	}

	.footer {
		display: flex;
		align-items: center;
		align-self: flex-end;
		justify-content: center;
		inline-size: 100%;
		margin-block-start: auto;
		padding: var(--gutterMedium);
		color: var(--hubBodyFontColor);
		border-block-start: 1px solid rgb(238 238 238);
	}

	.arrows {
		display: flex;
		align-items: center;
		justify-content: center;
		block-size: 16px;
		inline-size: 16px;
		margin-inline: 9px 9px;
		border-radius: 4px;
		background-color: rgb(230 237 241);
		line-height: 14px;
	}

	.disabled,
	.disabled > :global(.icon) {
		opacity: 0.4;
		cursor: default;
	}
</style>
